/** Public-site links must leave the current SPA when changing applications. */
export function siteUrl(path = '/') {
  return new URL(path, import.meta.env.VITE_SITE_URL || window.location.origin).href
}

export function paymentUrl(path: string) {
  const origin = import.meta.env.VITE_PAYMENT_BASE_URL
  if (!origin) throw new Error('VITE_PAYMENT_BASE_URL is required')
  return new URL(path, origin).href
}

export function apiFileUrl(path: string) {
  return new URL(path, import.meta.env.VITE_API_SERVER_URL || window.location.origin).href
}
